import {VMeterGroupCollection} from "../collections/VMeterGroups";
import {VMeterCollection} from "../collections/VMeters";
import {VMeterSourceCollection} from "../collections/VMeterSources";
import {BaseAppView, BaseAppViewOptions} from "../../_BaseAppViews";
import {ModuleCollection} from "../../../collections/Modules";
import {DashboardChannelCollection} from "../../../collections/DashboardChannels";
import {VMeterChannelCollection} from "../collections/VMeterChannels";
import {BaseModifyModalView, BaseModifyModalViewOptions} from "../../../views/modals/_BaseModifyModal";


/* The basic view for the Virtual Meter app */
export interface BaseVMeterAppViewOptions extends BaseAppViewOptions {
    vMeterGroupCollection: VMeterGroupCollection,
    vMeterGroupId: number,
    vMeterCollection: VMeterCollection,
    vMeterChannelCollection: VMeterChannelCollection,
    dashboardChannelCollection: DashboardChannelCollection;
    moduleCollections: { [key: number]: ModuleCollection; };
    vMeterSourceCollections: { [key: number]: VMeterSourceCollection; };
}

export interface VMeterNavOptions extends BaseVMeterAppViewOptions {
    isGrouped: boolean,
}

export class BaseVMeterAppView extends BaseAppView {

    options: BaseVMeterAppViewOptions;

    constructor(options: BaseVMeterAppViewOptions){
        super(options);
    }

}

export interface BaseVMeterModalViewOptions extends BaseVMeterAppViewOptions, BaseModifyModalViewOptions {}


export class BaseVMeterModalView extends BaseModifyModalView {

    options: BaseVMeterModalViewOptions;

    constructor(options: BaseVMeterModalViewOptions){
        super(options);
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/apps/vmeter/views/_BaseVMeterAppViews.ts